import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-md">
        <p className="font-heading font-bold text-6xl md:text-8xl text-primary-500">404</p>
        <h1 className="mt-4 font-heading font-semibold text-xl md:text-2xl text-foreground-800">Page introuvable</h1>
        <p className="mt-3 text-sm md:text-base text-secondary-500 leading-relaxed">
          La page que vous cherchez n'existe pas ou a été déplacée. Vous pouvez retourner à l'accueil ou nous appeler pour toute demande de dépannage.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
            Retour à l'accueil
          </Link>
          <a
            href="tel:+33980803684"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill w-4 h-4 flex items-center justify-center"></i>
            09 80 80 36 84
          </a>
        </div>
      </div>
    </div>
  );
}